import { ConfigOptions } from './../../ConfigOptions';
import { FrameworkConfiguration } from 'aurelia-framework';
export abstract class ConfigProvider { 
    public abstract get<T>(key: string): T;
    public abstract async init(config: FrameworkConfiguration, options: ConfigOptions): Promise<void>;
}